// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"2e4fb962","114":"2fdd8cd4","146":"70c900e1","163":"9d62f3e5","226":"7f7dbbd5","462":"749fa975","547":"727c9d25","638":"814472b8","657":"7a773991","852":"4f182ff6","967":"b1dcaaec"}[chunkId] + ".chunk.js";
};